<template>
  <div class="box2-page">
    <pageTitle title="短视频热度不减 助推个人目标快速达成" titleColor="#000" />
    <div class="content">
      <div class="content-item">
        <div class="item">
          <img class="item-left" src="../../../assets/topic-page/newMedia2/box2/img01.png" />
          <span>
            <h1>创业老板</h1>
            <p>有货源，流量高涨，生意爆火！</p>
          </span>
        </div>
        <div class="item">
          <img class="item-left" src="../../../assets/topic-page/newMedia2/box2/img02.png" />
          <span>
            <h1>稳定上班族</h1>
            <p>无货源能带货，发展副业高收入！</p>
          </span>
        </div>
      </div>

      <div class="content-item">
        <div class="item">
          <img class="item-left" src="../../../assets/topic-page/newMedia2/box2/img03.png" />
          <span>
            <h1>领域达人</h1>
            <p>经验分享，轻松变现！</p>
          </span>
        </div>
        <div class="item">
          <img class="item-left" src="../../../assets/topic-page/newMedia2/box2/img04.png" />
          <span>
            <h1>自由职业人</h1>
            <p>不入职场，短视频变现！</p>
          </span>
        </div>
        <div class="item">
          <img class="item-left" src="../../../assets/topic-page/newMedia2/box2/img05.png" />
          <span>
            <h1>运营新人</h1>
            <p>企业账号流量好，月月绩效高！</p>
          </span>
        </div>
      </div>

      <div class="content-item">
        <div class="item">
          <img class="item-left" src="../../../assets/topic-page/newMedia2/box2/img06.png" />
          <span>
            <h1>全职宝妈</h1>
            <p>带娃、创收两不误！</p>
          </span>
        </div>
        <div class="item">
          <img class="item-left" src="../../../assets/topic-page/newMedia2/box2/img07.png" />
          <span>
            <h1>有志青年</h1>
            <p>建设家乡，助力农村发展！</p>
          </span>
        </div>
      </div>
    </div>
    <div class="btn" @click="childMethod">立即咨询报名</div>
  </div>
</template>

<script>
import pageTitle from "../../../components/common/pageTitle.vue";

export default {
  components: {
    pageTitle,

  },
  name: '',
  data() {
    return {

    }
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  },
}
</script>

<style lang="scss" scoped>
.box2-page {
  padding: 80px 0 60px;
  .btn{
      width: 207px;
      height: 56px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 56px;
      border-radius: 28px;
      font-weight: bold;
      box-sizing: border-box;
      box-shadow: 0 8px 7px #e2b8db;
      background: url("../../../assets/topic-page/newMedia2/btnbg1.png") no-repeat;
      cursor: pointer;
      margin: 10px auto 0;
      padding-right: 20px;
      &:hover{
        box-shadow: none;
      }
    }
  .content {
    .content-item {
      display: flex;
      align-items: center;
      justify-content: center;

      .item {
        width: 417px;
        height: 117px;
        background: url("../../../assets/topic-page/newMedia2/box2/bg.png") no-repeat;
        background-size: 100% 100%;
        background-position: center;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0 21px 24px;

        .item-left {
          width: 70px;
          height: 70px;
          margin-right: 14px;

        }

        span {
          h1 {
            font-family: PingFangSC-Semibold;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 0px;
            color: #1a0a0e;
            margin-bottom: 8px;
          }

          p {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            font-weight: normal;
            letter-spacing: 0px;
            color: #1a0a0e;
          }
        }
      }
    }
  }
}
</style>